import { Button, useRole } from "@4uhub/lib4uhub";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { Box, Popover } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DeleteModal } from "./DeleteModal/DeleteModal";

interface IDashboardCardPopoverProps {
  id: string;
  openModal: boolean;
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  openModalHandler: () => void;
  closeModalHandler: () => void;
}

const TRANSLATION_PATH = "page.panels.";

export const DashboardCardPopover = memo(
  ({
    id,
    openModal,
    anchorEl,
    handleClose,
    openModalHandler,
    closeModalHandler,
  }: IDashboardCardPopoverProps) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const open = Boolean(anchorEl);

    const popoverId = open ? "panel-grid-popover" : undefined;

    const hasDeletePermission = useRole(["Delete"]);

    const hasUpdatePermission = useRole(["Update"]);

    const handleEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.stopPropagation();
      navigate(`${id}/edit`);
    };

    return (
      <>
        <DeleteModal
          id={id}
          openModal={openModal}
          closeModalHandler={closeModalHandler}
        />

        <Popover
          id={popoverId}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Box
            sx={{
              p: 1,
              width: 150,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {hasUpdatePermission && (
              <Button
                startIcon={<EditRoundedIcon />}
                fullWidth
                color="inherit"
                sx={{ display: "flex", justifyContent: "start" }}
                onClick={handleEdit}
              >
                {t(TRANSLATION_PATH + "edit")}
              </Button>
            )}
            {hasDeletePermission && (
              <Button
                startIcon={<DeleteRoundedIcon />}
                fullWidth
                color="error"
                sx={{ display: "flex", justifyContent: "start" }}
                onClick={openModalHandler}
              >
                {t(TRANSLATION_PATH + "delete")}
              </Button>
            )}
          </Box>
        </Popover>
      </>
    );
  }
);
